export default __webpack_public_path__ + "./fonts/keyboard_arrow_down.29295fb5.svg";